<template>
	<div>

		<div class="bg-white js-fix-footer border-top-2">
			<div class="container page-section py-lg-48pt">
				<div class="row">
					<div class="col-md-4">
						<div class="row">
							<!--<div class="col-6 col-md-5 mb-24pt mb-md-0">-->
								<!--<h4 class="text-black-70">Learn</h4>-->
								<!--<nav class="nav nav-links nav&#45;&#45;flush flex-column">-->
									<!--<router-link-->
											<!--class="nav-link"-->
											<!--active-class="active"-->
											<!--:to="{name: 'dashboard'}">Get Started-->
									<!--</router-link>-->
									<!--<router-link-->
											<!--class="nav-link"-->
											<!--active-class="active"-->
											<!--:to="{name: 'dashboard'}">Courses-->
									<!--</router-link>-->
									<!--<router-link-->
											<!--class="nav-link"-->
											<!--active-class="active"-->
											<!--:to="{name: 'forum'}">Questions-->
									<!--</router-link>-->


								<!--</nav>-->
							<!--</div>-->

							<div class="col-6 col-md-5 mb-32pt mb-md-0" style="top: 10px;">
								<h4 class="text-black-70">Community</h4>
								<nav class="nav nav-links nav--flush flex-column">
									<router-link
											class="nav-link"
											active-class="active"
											:to="{name: 'forum'}">Discussions
									</router-link>

									<router-link
											class="nav-link"
											active-class="active"
											:to="{name: 'user-profile', params: {id}}" exact>

										User Profile
									</router-link>

									<router-link
											class="nav-link"
											active-class="active"
											:to="{name: 'dashboard'}">Dashboard
									</router-link>


								</nav>
							</div>
						</div>
					</div>
					<div class="col-md-8 text-md-right" style="    margin-top: 20px;">
						<p class="text-black-70 brand justify-content-md-end">
							<img class="brand-icon" src="/assets/images/logo/white-100.svg" width="30" alt="N-Power">
							N-Power
						</p>
						<p class="">N-Power is an initiative of the National Social Investment Programme of the Federal
							Government of Nigeria, with a  focus to provide young graduates and non-graduates with the
							skills, tools and livelihood that will help them advance from unemployment to employment,
							entrepreneurship and innovation.
						</p>
					</div>
				</div>
			</div>
			<div class="bg-footer page-section py-lg-32pt">
				<div class="container">
					<div class="row">
						<div class="col-md-2 col-sm-4 mb-24pt mb-md-0">
							<!--<p class="text-white-70 mb-8pt"><strong>Follow us</strong></p>-->
							<!--<nav class="nav nav-links nav&#45;&#45;flush">-->
								<!--<a href="#" class="nav-link mr-8pt"><img src="/assets/images/icon/footer/facebook-square.svg"-->
																		 <!--alt="Facebook"></a>-->
								<!--<a href="#" class="nav-link mr-8pt"><img src="/assets/images/icon/footer/twitter-square.svg"-->
																		 <!--alt="Twitter"></a>-->

								<!--<a href="#" class="nav-link"><img src="/assets/images/icon/footer/youtube-square.svg" alt="YouTube"></a>-->
							<!--</nav>-->
						</div>
						<div class="col-md-6 col-sm-4 mb-24pt mb-md-0 d-flex align-items-center">
						</div>
						<div class="col-md-4 text-md-right">
							<!--<p class="mb-8pt d-flex align-items-md-center justify-content-md-end">-->
								<!--<a href="" class="text-white-70 text-underline mr-16pt">Terms</a>-->
								<!--<a href="" class="text-white-70 text-underline">Privacy policy</a>-->
							<!--</p>-->
							<p class="text-white-50 mb-0">Copyright 2019 &copy; All rights reserved.</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Modal -->
		<div class="modal" id="courses" tabindex="-1" role="dialog">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-body">

						<button type="button" class="close" data-dismiss="modal">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
export default {
	name: 'Footer',
	data() {
		return {
			date: (new Date()).getFullYear(),
           	id : this.$session.get('id')
		}
	},

};
</script>

<style lang="scss" scoped>
	.link--contact {
		white-space: normal;
	}
</style>
